import styles from './styles.module.css';
import CardMedium from './CardMedium';
import DateRangePicker from '../../../common/components/DateRangePicker';
import CardSmall from './CardSmall';
import { Dropdown, LineChartCard } from '../../../common/ui';
import PieChartCard from './PieChartCard';
import {
  getSalesDataByDate,
  getSalesDataByDateRange,
  getPaymentMethodUsedForToday,
  getSalesDataAgainstDate,
  getPaymentMethodUsedForRange,
} from '../actions/index';
import { setBranchId } from '../../auth/actions';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const Dashboard = ({
  getSalesDataByDate,
  getSalesDataByDateRange,
  getPaymentMethodUsedForToday,
  getSalesDataAgainstDate,
  getPaymentMethodUsedForRange,
  setBranchId,
  dashboard: {
    totalSalesToday,
    totalCostToday,
    totalProfitToday,
    numberOfBillsToday,
    loadingTodayData,
    totalSalesRange,
    totalCostRange,
    totalProfitRange,
    numberOfBillsRange,
    loadingRangeData,
    salesWiseBillCountToday,
    pieChartTodayLoading,
    salesWiseBillCountRange,
    pieChartRangeLoading,
    loadingGraphData,
    salesDataAgainstDateForGraph,
  },
  auth: { branchList, branchId },
}) => {
  const getThisMonthDates = () => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return [firstDay, lastDay];
  };

  const [dateRange, setDateRange] = useState(getThisMonthDates());

  useEffect(() => {
    if (branchId) {
      getSalesDataByDate(new Date());
      getPaymentMethodUsedForToday(new Date());
    }
  }, [branchId]);

  useEffect(() => {
    if (branchId) {
      getSalesDataByDateRange(dateRange);
      getSalesDataAgainstDate(dateRange);
      getPaymentMethodUsedForRange(dateRange);
    }
  }, [dateRange, branchId]);

  const handleChangeBranch = (value) => {
    setBranchId(value);
  };

  const handleDateRangeChange = (dateRangeObj) => {
    if (dateRangeObj.startDate && dateRangeObj.endDate) {
      setDateRange([dateRangeObj.startDate, dateRangeObj.endDate]);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.pageTitle}>Dashboard</h1>
        {branchId && branchList && branchList.length > 0 && (
          <div className={styles.branchSelectWrap}>
            <Dropdown
              label="Branch"
              id="branch-select"
              options={branchList.map((item) => ({
                value: item.id,
                label: item.name,
              }))}
              value={branchId}
              onChange={handleChangeBranch}
              aria-label="Select branch"
            />
          </div>
        )}
      </div>
      <div className={styles.body}>
        <div className={styles.datePickerWrap}>
          <Dropdown
            options={[{ value: 'Today', label: 'Today' }]}
            value="Today"
            onChange={() => {}}
            aria-label="Date range"
          />
        </div>
        <div className={styles.topContainer}>
          <div className={styles.topContainerLeft}>
            {loadingTodayData ? (
              <>
                {[1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    className={`${styles.skeleton} ${styles.skeletonCard}`}
                  />
                ))}
              </>
            ) : (
              <>
                <CardMedium
                  amount={totalSalesToday}
                  color="green"
                  title="Total Sales"
                  value="0%"
                />
                <CardMedium
                  amount={totalCostToday}
                  color="green"
                  title="Total Cost"
                  value="0%"
                />
                <CardMedium
                  amount={totalProfitToday}
                  color="green"
                  title="Total Profit"
                  value="0%"
                />
                <CardMedium
                  amount={numberOfBillsToday}
                  color="green"
                  title="Number of Bills"
                  value="0%"
                />
              </>
            )}
          </div>
          <div className={styles.topContainerRight}>
            {pieChartTodayLoading ? (
              <div
                className={`${styles.skeleton} ${styles.skeletonChart}`}
              />
            ) : (
              <PieChartCard
                title="Payment Methods Usage"
                data={salesWiseBillCountToday}
              />
            )}
          </div>
        </div>
        <div className={styles.bottomContainer}>
          <div className={styles.dateRangePickerWrap}>
            <DateRangePicker
              onDateRangeChange={handleDateRangeChange}
              initialStartDate={dateRange[0]}
              initialEndDate={dateRange[1]}
            />
          </div>

          <div className={styles.cardContainer}>
            {loadingRangeData ? (
              <>
                {[1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    className={`${styles.skeleton} ${styles.skeletonCardSmall}`}
                  />
                ))}
              </>
            ) : (
              <>
                <CardSmall
                  amount={totalSalesRange}
                  color="green"
                  title="Total Sales"
                  value="0%"
                />
                <CardSmall
                  amount={totalCostRange}
                  color="green"
                  title="Total Cost"
                  value="0%"
                />
                <CardSmall
                  amount={totalProfitRange}
                  color="green"
                  title="Total Profit"
                  value="0%"
                />
                <CardSmall
                  amount={numberOfBillsRange}
                  color="green"
                  title="Number of Bills"
                  value="0%"
                />
              </>
            )}
          </div>
          <div className={styles.bottomChartContainer}>
            <div className={styles.chartContainerLeft}>
              {pieChartRangeLoading ? (
                <div
                  className={`${styles.skeleton} ${styles.skeletonChart}`}
                />
              ) : (
                <PieChartCard
                  title="Payment Methods Usage"
                  data={salesWiseBillCountRange}
                />
              )}
            </div>
            <div className={styles.chartContainerRight}>
              {loadingGraphData ? (
                <div
                  className={`${styles.skeleton} ${styles.skeletonLineChart}`}
                />
              ) : (
                <LineChartCard data={salesDataAgainstDateForGraph} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Dashboard.propTypes = {
  getSalesDataByDate: PropTypes.func.isRequired,
  getSalesDataByDateRange: PropTypes.func.isRequired,
  getPaymentMethodUsedForToday: PropTypes.func.isRequired,
  getSalesDataAgainstDate: PropTypes.func.isRequired,
  getPaymentMethodUsedForRange: PropTypes.func.isRequired,
  setBranchId: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  dashboard: state.dashboard,
  auth: state.authState,
});

export default connect(mapStateToProps, {
  getSalesDataByDate,
  getSalesDataByDateRange,
  getPaymentMethodUsedForToday,
  getSalesDataAgainstDate,
  getPaymentMethodUsedForRange,
  setBranchId,
})(Dashboard);
